import { ChatBase } from '@parcel2go/npm-p2g-app';
import { P2GButton, P2GFade } from '@parcel2go/core-ui';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { ReactNode } from 'react';
import { useChatContext } from '~/hooks/use-chat-context';

interface props {
  onButtonShow?: () => void;
  onOpenChat?: () => void;
  label?: string;
  customButton?: ReactNode;
  /** Associates the chat with an order, where the surface relates to a specific one. */
  orderReference?: string;
}

const ChatButton = (props: props) => {
  const liveChatEnabled =
    !!SettingsCache.settings.LiveChatConfiguration || SettingsCache.settings.Features.includes('LiveChat');

  // Gated, not just unused: this component renders nothing when live chat is off, and a hidden
  // button on the action menu or version card should not be fetching VIP details.
  const contextParams = useChatContext({ enabled: liveChatEnabled });

  return liveChatEnabled ? (
    <ChatBase
      onOpenChat={props.onOpenChat}
      onButtonShow={props.onButtonShow}
      orderReference={props.orderReference}
      contextParams={contextParams}
      children={
        props.customButton ? (
          props.customButton
        ) : (
          <P2GFade in>
            <P2GButton variant="secondary">{props.label}</P2GButton>
          </P2GFade>
        )
      }
    />
  ) : null;
};

export default ChatButton;
